import { render, staticRenderFns } from "./DegreeImport.vue?vue&type=template&id=43681d5e&scoped=true&"
import script from "./DegreeImport.vue?vue&type=script&lang=js&"
export * from "./DegreeImport.vue?vue&type=script&lang=js&"
import style0 from "./DegreeImport.vue?vue&type=style&index=0&id=43681d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43681d5e",
  null
  
)

export default component.exports